var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField as MaterialTextField } from '@mui/material';
import { fieldValueIsSame, localeIsSame, disabledIsSame, } from '../../utils/formik';
import withDefaultProps from '../../utils/withDefaultProps';
var TextField = withDefaultProps(MaterialTextField, {
    variant: 'outlined',
});
TextField.displayName = 'TextField';
export default TextField;
var FormikTextFieldUnmemoized = function (_a) {
    var _b = _a.formik, errors = _b.errors, handleBlur = _b.handleBlur, handleChange = _b.handleChange, values = _b.values, textFieldProps = __rest(_a, ["formik"]);
    var nameAsKey = textFieldProps.name;
    return (React.createElement(TextField, __assign({ onBlur: handleBlur, onChange: handleChange, value: values[nameAsKey], error: Boolean(errors[nameAsKey]), helperText: errors[nameAsKey] }, textFieldProps)));
};
export var FormikTextField = React.memo(FormikTextFieldUnmemoized, function (prevProps, nextProps) {
    return localeIsSame(prevProps, nextProps) &&
        fieldValueIsSame(prevProps, nextProps) &&
        disabledIsSame(prevProps, nextProps);
});
